// toolRegistry.js
import PublicIcon from "@mui/icons-material/Public";
import MenuBookIcon from "@mui/icons-material/MenuBook";
// import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
// import ImageIcon from "@mui/icons-material/Image";

/**
 * Add new tools here. Fields:
 * id: string unique id
 * label: displayed label
 * icon: MUI icon component
 * mode: "toggle" | "one-shot" | "modal"
 * metadataKey: key to put into metadata.tools
 * defaultOneShot: boolean (if mode "one-shot", indicates auto-clear)
 */
export const TOOL_REGISTRY = [
  {
    id: "external_sources",
    label: "External Sources",
    icon: PublicIcon,
    mode: "toggle",
    metadataKey: "external_sources",
    synapse360Disclaimer:
      "You've selected External Sources, so answers will come from CT.gov and PubMed. To return to general Synapse360 questions, deselect External Sources.",
  },
  {
    id: "knowledge_bot",
    label: "Training Compass",
    icon: MenuBookIcon,
    mode: "toggle",
    metadataKey: "knowledge_bot",
    synapse360Disclaimer:
      "You've selected Training Compass, so answers will come from the Commercial Tech Training Site. To return to general Synapse360 questions, deselect Training Compass.",
  },
  // {
  //   id: "upload_doc",
  //   label: "Upload Document",
  //   icon: InsertDriveFileIcon,
  //   mode: "modal",
  //   metadataKey: "upload_doc",
  // },
  // {
  //   id: "image_gen",
  //   label: "Create Image",
  //   icon: ImageIcon,
  //   mode: "modal",
  //   metadataKey: "image_generation",
  // },
];

export const getToolSynapse360Disclaimer = (toolId) =>
  TOOL_REGISTRY.find((tool) => tool.id === toolId)?.synapse360Disclaimer || null;
